
import {Component, Input, OnInit, ElementRef, ViewEncapsulation, AfterViewInit,
  OnChanges, AfterContentInit, Attribute, Renderer2, Inject} from '@angular/core';
// declare var marked: any;
@Component({
  selector: 'abs-tabs,[abs-tabs]',
  template: `<ng-content></ng-content>`,
  styles: [`.inactive-toggle-header,.toggle-header{border-color:#fff;color:#0568ae;cursor:pointer;display:block;font-size:2rem;line-height:1.2rem;min-height:41px;position:relative;padding:16px 55px 16px 15px}.tiny-accordion-to-tabs>abs-tab-group>.toggle-header{background-clip:padding-box;background-color:#fff;border-bottom:1px solid #d2d2d2;border-radius:0;border-right:1px solid #d2d2d2;border-top:1px solid #fff;display:inline-block;-webkit-filter:none;filter:none;float:left;font-weight:400;height:70px;padding:26px 20px 25px;text-align:center;white-space:nowrap}.tiny-tabs .toggle-header{height:71px;padding:22px 20px 25px!important;border-top:5px solid #fff}.tiny-tabs .toggle-header+div{left:0;position:absolute;top:69px;border-top:1px solid #d2d2d2;padding:0;display:block;border-bottom:none;width:100%}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header{border-right:0;border-left:0}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header.closed:last-child,.tiny-accordion-to-tabs>abs-tab-group:last-of-type>.toggle-header:not(.opened){border-right:none}.tiny-accordion-to-tabs,.tiny-tabs{position:relative;width:100%;margin:0;padding:0}.tiny-accordion-to-tabs:after,.tiny-accordion-to-tabs:before,.tiny-tabs:after,.tiny-tabs:before{display:table;content:"";line-height:0}.tiny-accordion-to-tabs:after,.tiny-tabs:after{clear:both}.tiny-tabs .toggle-header.opened{border-bottom:0!important}.tiny-tabs .opened:nth-last-of-type(2){border-right:1px solid #d2d2d2}.tiny-tabs .opened:first-child{border-left:1px solid #d2d2d2}.tiny-tabs .toggle-header:first-child{margin-left:0}.tiny-tabs .opened{color:#191919;border-top:none!important;padding-top:27px!important;border-bottom:none;background-color:#fff;-webkit-filter:none;filter:none;cursor:default;z-index:999}.toggle-header.opened{color:#191919}.focus--mouse,.focus-mouse{outline:0}[aria-controls]{cursor:pointer}.tiny-tabs .opened:before{content:"";background-color:#0568ae;height:5px;width:100%;position:absolute;top:0;left:0}.tiny-tabs [class*=icon-accordion-]{display:none!important}.toggle-header .icon-accordion-minus,.toggle-header .icon-accordion-plus{display:inline-block;font-size:20px;margin-top:-13px;padding:0;position:absolute;right:15px;vertical-align:middle;top:50%}.accordion-content{-webkit-transition:max-height 1s;transition:max-height 1s;overflow:hidden;font-size:1.6rem}.accordion-pad{padding-top:30px}@media (min-width:768px){.tiny-accordion-to-tabs .toggle-header+div,.tiny-tabs .toggle-header+div{left:0;position:absolute;top:69px;border-top:1px solid #d2d2d2;padding-top:30px;padding-left:20px;display:block;border-bottom:none;width:100%}.tiny-tabs .toggle-header+div .accordion-pad{padding-top:0;padding-bottom:0}}.tiny-accordion-to-tabs .toggle-header:first-child{margin-left:0}.tiny-accordion-to-tabs .opened{background-color:#fff;border-bottom:none;color:#191919;cursor:default;-webkit-filter:none;filter:none;padding-top:22px!important;text-decoration:none;z-index:999}@media (max-width:767px){.tiny-accordion-to-tabs{display:block;border-bottom:1px solid #d2d2d2}.tiny-accordion,.tiny-accordion-to-tabs{margin-left:-15px;margin-right:-15px;width:auto}.tiny-accordion-to-tabs div.toggle-header+.accordion-content{padding:0 50px 15px 15px}.tiny-accordion-to-tabs div.toggle-header .icon-accordion-plus{background-position:0 0;background-size:20px 40px}.tiny-accordion-to-tabs div.toggle-header{display:block!important;float:none;text-align:left;border-top:1px solid #ccc!important;border-bottom:0;border-right:0;padding:16px 50px 16px 15px!important;height:47px}.tiny-accordion-to-tabs div.toggle-header:first-child{margin-left:0!important}.tiny-accordion-to-tabs .toggle-header{display:block;min-height:41px;padding:16px 50px 16px 15px;border-top:1px solid #d2d2d2}.tiny-accordion-to-tabs .toggle-header:focus{text-decoration:none}}@media (min-width:768px){.tiny-accordion-to-tabs>abs-tab-group:first-of-type>.toggle-header.opened{border-left:1px solid #d2d2d2}.tiny-accordion-to-tabs.row-nowrap>abs-tab-group>.toggle-header{border-right:1px solid #d2d2d2;border-left:0}.tiny-accordion-to-tabs .opened{color:#191919;border-top:none!important;padding-top:27px!important;border-bottom:none;background-color:#fff;-webkit-filter:none;filter:none;cursor:default;text-decoration:none;z-index:999}.tiny-accordion-to-tabs .opened:nth-last-of-type(2){border-right:1px solid #d2d2d2}.tiny-accordion-to-tabs .opened:first-child{border-left:1px solid #d2d2d2}.tiny-accordion-to-tabs .toggle-header:first-child{border-left:1px solid #fff}.tiny-accordion-to-tabs .toggle-header:nth-last-of-type(2){border-right:none}.tiny-accordion-to-tabs .opened:before{content:"";background-color:#0568ae;height:5px;width:100%;position:absolute;top:0;left:0}.tiny-accordion-to-tabs [class*=icon-accordion-]{display:none!important}}.tiny-accordion{border-bottom:1px solid #d2d2d2}.tiny-accordion .inactive-toggle-header,.tiny-accordion .toggle-header{line-height:2.3rem!important;padding:16px 55px 16px 15px;padding-top:14px!important;border-top:1px solid #d2d2d2}.tiny-accordion .toggle-header+.accordion-content{padding:0 50px 15px 15px}`],
  encapsulation: ViewEncapsulation.None
})
// this is the parent of different groups or a wrapper for accordion-group
export class AbsTabComponent implements OnInit, AfterViewInit, OnChanges {
  @Input('scrollTop') scrollTop: boolean = false;
  @Input('expandAll') expandAll: any; //  input type true expand all the groups
  @Input('collapseAll') collapseAll: any; //  input type true collapse all groups
  @Input('closeOthers') public closeOthers: any; //  iput type true will allow only one group to open at a time
  @Input('maxWidth') public maxWidth: any;
  public isMultiSelect; // local variable for closeOthers to be false
  public accordionID; //  local variable to set the accordionId passed by users
  public accordionPanelHeight = [];
  groups: any = [];  // Array of groups in accordion
  public index = -1;
  forceExpand = false; // variable used in fnExpandAll for initilazing the Expand state
  constructor(
      @Inject(ElementRef) public element: ElementRef,
      @Attribute('id') public id: any, // to set the accordionId passed by users
      @Attribute('iconPosition') public iconPosition: any,
      @Attribute('isFilter') public isFilter,
      @Inject(Renderer2) public renderer: Renderer2) {
  }

  ngOnInit() {
      // To initialy set accordionID and iconLeft class to the accordion if its position is left
      this.isMultiSelect = this.isCloseOthers();
      this.accordionID = this.id;
      this.setID(this.accordionID);
      if (this.iconPosition === 'left') {
          this.addClass(this.element.nativeElement, 'iconleft');
      }

  }

  ngOnChanges(changes) {
      // calling expandAll or collapseAll functions based on change variable
      if (changes.collapseAll === undefined && changes.expandAll !== undefined) {
          if (changes.expandAll.currentValue === this.expandAll) {
              this.fnExpandAll();
          }
      }
      if (changes.expandAll === undefined && changes.collapseAll !== undefined) {
          if (changes.collapseAll.currentValue === this.collapseAll) {
              this.fnCollapseAll();
          }
      }

  }

  ngAfterViewInit() {
      if (this.maxWidth) {
          this.resizeTabsAccordionWithMaxWidth();
          this.renderer.listen(window, 'resize', (event) => {
              this.resizeTabsAccordionWithMaxWidth();
          })
      }
  }

  addClass(element, className) {
      //  To add a class on some element
      this.renderer.addClass(element, className);
  }

  removeClass(element, className) {
      this.renderer.removeClass(element, className);
  }

  hasClass(element, className) {
      //  To check the class on any eement
      return (element.className.indexOf(className) > -1) ? true : false;
  }

  fnCloseOthers(openGroup, closeOthersFlag) {
      //  Function to close others except the one which is clicked
      if (closeOthersFlag) {
          for (let i = 0; i < this.groups.length; i++) {
              if (openGroup.accordion.groups[i].isOpen === false) {
                  this.groups[i].isOpen = false;
              }
          }
      }
  }

  deSelectOthers(openGroup) {       
      if (!this.isMultiSelect) {
          for (let i = 0; i < this.groups.length; i++) {
              if (this.groups[i] !== openGroup) {
                  this.groups[i].isSelected = false;
                  this.groups[i].tab.tabIndex = -1;
              } 
              else
              {
                  this.groups[i].isSelected = true;
                  this.groups[i].tab.tabIndex = 0;
              }
          }
      }

  };

  isLastOpen(){
      var openCount = 0;
      for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i].isOpen === true) {
              openCount++;
          }
      }
      return !(openCount > 0);
  };


  fnExpandAll() {
      // Function to expand all groups inside a accordion
      this.forceExpand = true;
      for (let i = 0; i < this.groups.length; i++) {
          this.groups[i].isOpen = true;
      }
  }

  fnCollapseAll() {
      // Function to collapse all groups inside a accordion
      for (let i = 0; i < this.groups.length; i++) {
          this.groups[i].isOpen = false;
      }
  }

  isCloseOthers() {
      //  To check if the other accordion groups are closed or not..
      const closeOthers = (this.closeOthers !== undefined) ? this.closeOthers : false;
      return closeOthers;
  }

  focus(focusGroup) {
      //  To bring the focus on a particular group
      const self = this;
      for (let i = 0; i < this.groups.length; i++) {
          if (this.groups[i] !== focusGroup) {
              this.groups[i].focused = false;
          } else {
              self.index = i;
              this.groups[i].focused = true;
          }
      }
  }

  // This is called from the accordion-group directive to add itself to the accordion
  addGroup(groupScope) {
      groupScope.index = this.groups.length;
      groupScope.focused = false;
      this.groups.push(groupScope);
  }

  // This is called from the accordion-group directive when to remove itself
  removeGroup(group) {
      const index = this.groups.indexOf(group);
      if (index !== -1) {
          this.groups.splice(this.groups.indexOf(group), 1);
      }
  }

  getSize() {
      return this.groups.length;
  }

  //  To set height of the group according to the value passed
  setHeight(val) {
      this.element.nativeElement.style.minHeight = val + 'px';
  }


  // to set id for each accordion group
  setID(id) {
      for (let i = 0; i < this.groups.length; i++) {
          this.groups[i].acID = id;
      }
  }

  elementHeight(newVal, oldVal) {
      if (!this.hasClass(this.element.nativeElement, 'tiny-accordion')) {
          this.element.nativeElement.style.minHeight = newVal;
          this.element.nativeElement.style.height = 'auto';
      }
  }
  cycle(group, down) {
      // to select the group from the given list and to pass focus from last to first element or from first to last in a cyclic order
      if (!down) {
          if (group.index <= 0) {
              group.index = this.groups.length - 1;
          } else {
              group.index--;
          }
      } else {
          if (group.index >= (this.groups.length - 1)) {
              group.index = 0;
          } else {
              group.index++;
          }
      }
      this.groups[group.index].index = group.index;
      //this.groups[group.index].element.nativeElement.setAttribute('tabIndex', '0');
      this.groups[group.index].element.nativeElement.children[0].focus();
  }
  public resizeTabsAccordionWithMaxWidth() {
      const instance = this;
      setTimeout(() => {
          if (!instance.hasClass(instance.element.nativeElement, 'tiny-tabs')) {
              if (parseInt(instance.element.nativeElement.offsetWidth,10) < instance.maxWidth) {
                  instance.removeClass(instance.element.nativeElement, 'tiny-accordion-to-tabs');
                  instance.removeClass(instance.element.nativeElement, 'row-nowrap');
                  instance.addClass(instance.element.nativeElement, 'tiny-accordion')
                  instance.addClass(instance.element.nativeElement, 'changed-by-accordion')
                  instance.element.nativeElement.style.height = 'auto';
              } else {
                  instance.removeClass(instance.element.nativeElement, 'tiny-accordion')
                  instance.removeClass(instance.element.nativeElement, 'changed-by-accordion')
                  instance.addClass(instance.element.nativeElement, 'tiny-accordion-to-tabs');
                  instance.addClass(instance.element.nativeElement, 'row-nowrap');
              }
          }
      }, 400);
  }
  public scrollTo(instance) {
      instance.scrollIntoView({ behavior: 'smooth' });
  }
}